import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import Cookies from "js-cookie";

// Import modules
import __rules from "./__helpers/__rules";
import __global from "./__helpers/__global";
import __modal from "./__helpers/__modal";

//Import Api Stores
import logoutDialog from "./dialog";
import authentication from "./authentication";
import registeredUser from "./registeredUser";

import countries from "./countries";
import cities from "./cities";
import states from "./states";
import newUser from "./newUser";
import clientsDocuments from "./clientsDocuments";
import profile from "./profile";
import blockedusers from "./blockedusers";
import demoaccounts from "./demoaccounts";
import testingaccounts from "./testingaccounts";
import liveaccounts from "./liveaccounts";
import inactiveaccounts from "./inactiveaccounts";
import lowbalanceaccounts from "./lowbalanceaccounts";
import accounttypes from "./accounttypes";
import loginactivities from "./loginactivities";
import markettingtools from "./markettingtools";
import currencies from "./currencies";
import partnerlist from "./partnerlist";
import commissionsettings from "./commissionsettings";
import partnerwithdraw from "./partnerwithdraw";
import livetrades from "./livetrades";
import closedtrades from "./closedtrades";
import tradablebonus from "./tradablebonus";
import shortdurationtrades from "./shortdurationtrades";
import trxsummaries from "./trxsummaries";
import trxdeposit from "./trxdeposit";
import trxwithdrawal from "./trxwithdrawal";
import trxinternal from "./trxinternal";
import trxcreditin from "./trxcreditin";
import trxcreditout from "./trxcreditout";
import rmssettings from "./rmssettings";
import news from "./news";
import tickets from "./tickets";
import marketingdata from "./marketingdata";
import serverconfig from "./serverconfig";
import emailconfig from "./emailconfig";
import leverage from "./leverage";
import generalinfo from "./generalinfo";
import accgroups from "./accgroups";
import brokersbank from "./brokersbank";
import cryptoaddress from "./cryptoaddress";
import admins from "./admins";
import partnerpaymethods from "./partnerpaymethods";
import reguserdetails from "./reguserdetails";
import dashboard from "./dashboard";
import adminnotification from "./adminnotification";
import userlivetrades from "./userlivetrades";
import userclosedtrades from "./userclosedtrades";
import clientbanks from "./clientbanks";
import mam from "./mam";
import trademaster from "./trademaster";
import contest from "./contest";
import commissiontree from "./commissiontree";
import ibrequest from "./ibrequest";
import chart from "./chart";
import assignacctype from "./assignacctype";
import levelunlock from "./levelunlock";
import loader from './modules/loader';
import company from "./company";
import agreements from "./agreements";
import mamwallet from "./mamwallet";
import investor from "./investor";

import wallettrx from "./wallettrx";
import managerswallet from "./managerswallet";  
import investorswallet from "./investorswallet";

Vue.use(Vuex);


const state = {
  baseUrl: '/'
};

const getters = {};
const mutations = {};
const actions = {};

const plugins = [
  createPersistedState({
    key: "fx_ap",
    paths: ["authentication.token"],
    storage: {
      getItem: (key) => Cookies.get(key),
      setItem: (key, value) => Cookies.set(key, value, { expires: 1 }), //1day
      removeItem: (key) => Cookies.remove(key),
    },
  }),
];

export default new Vuex.Store({
  strict: true,
  state,
  getters,
  mutations,
  actions,
  modules: {
    __global,
    __rules,
    __modal,
    // components start
    logoutDialog,
    authentication,
    registeredUser,
    countries,
    cities,
    states,
    newUser,
    clientsDocuments,
    profile,
    blockedusers,
    demoaccounts,
    testingaccounts,
    liveaccounts,
    inactiveaccounts,
    lowbalanceaccounts,
    accounttypes,
    loginactivities,
    markettingtools,
    currencies,
    partnerlist,
    commissionsettings,
    partnerwithdraw,
    livetrades,
    closedtrades,
    shortdurationtrades,
    trxsummaries,
    trxdeposit,
    trxwithdrawal,
    trxinternal,
    trxcreditin,
    trxcreditout,
    rmssettings,
    news,
    tickets,
    marketingdata,
    serverconfig,
    emailconfig,
    leverage,
    generalinfo,
    accgroups,
    brokersbank,
    cryptoaddress,
    admins,
    partnerpaymethods,
    reguserdetails,
    dashboard,
    adminnotification,
    userlivetrades,
    userclosedtrades,
    clientbanks,
    mam,
    mamwallet,
    wallettrx,
    managerswallet,
    investorswallet,
    trademaster,
    contest,
    commissiontree,
    ibrequest,
    chart,
    assignacctype,
    levelunlock,
    loader,
    company,
    agreements,
    tradablebonus,
    investor
  },
  plugins,
});
